import { featureRequestsValidator } from "@/validators";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/_app/feedback/")({
  validateSearch: zodValidator(featureRequestsValidator),
  loaderDeps: (search) => search,
});
